import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../assets/aveti.png";
import useAuth from "../../contexts/UserContext.tsx";
import "./sidebar.scss";

const SidebarSmartClass = () => {
  const { logout, user } = useAuth();
  const media = useMediaQuery("(max-width: 768px)");
  const [collapsed, setCollapsed] = useState(media);
  const schoolID = user.view_access_list.schoolID;
  return (
    <div
      className={
        collapsed
          ? "sidebar max-w-xs min-w-fit dark:bg-grey-50 collapsed"
          : "sidebar max-w-xs min-w-fit dark:bg-grey-50"
      }
    >
      <div className="top">
        <img src={logo} alt="logo" className="w-24 py-2 flex mx-auto" />
        {media ? (
          <div className="menuIcon">
            {
              <IconButton
                fontSize="small"
                onClick={() => setCollapsed((prev) => !prev)}
              >
                {collapsed ? <MenuIcon /> : <ArrowBackIosIcon />}
              </IconButton>
            }
          </div>
        ) : null}
      </div>
      <hr />
      <div className="center">
        <div className="menuGroup">
          <p className="title">Smart Class</p>
          <ul>
            <li>
              <NavLink
                className="w-full px-2 rounded"
                to={`/smartclass/school/${schoolID}`}
                style={{ textDecoration: "none" }}
              >
                <DashboardIcon className="icon" />
                <span>Dashboard</span>
              </NavLink>
            </li>
          </ul>
        </div>

        <div className="menuGroup">
          <p className="title">User</p>
          <ul>
            <li>
              <button onClick={logout}>
                <ExitToAppIcon className="icon" />
                <span>Logout</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SidebarSmartClass;
